import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const HeaderBar = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '3%',
  paddingRight: '3%'
});

const GridWrapper = styled(Box)({
  height: '100%',
  width: '100%'
});

const Title = styled(Typography)({
  fontWeight: 'bold'
});

const AddGradeScaleButton = styled(Button)({
  marginBottom: '16px'
});

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: '1px solid #ccc',
  borderRadius: '12px',
  backgroundColor: '#fff',
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid #ddd',
    borderRight: '1px solid #ddd'
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none !important'
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
    fontWeight: 'bold',
    '& .MuiDataGrid-columnHeader': {
      borderRight: '1px solid #ddd'
    }
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold'
  },
  '& .MuiDataGrid-row': {
    border: 'none'
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none'
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none'
    },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#fafafa'
  }
}));

const DialogHeaderBar = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 16,
  marginRight: 32,
  marginLeft: 32
});

const DialogGridWrapper = styled(Box)({
  height: '100%',
  width: '100%',
  marginTop: 16
});

export {
  HeaderBar,
  GridWrapper,
  Title,
  AddGradeScaleButton,
  StyledDataGrid,
  DialogHeaderBar,
  DialogGridWrapper
};
